/**
 * Used for more granular permissions
 */
export enum Capability {
    // Can the user access the shop, buy from the shop, etc.
    CAN_SHOP = 1,
    CAN_BUY_TOKENS = 2
}


// WEBPACK FOOTER //
// ./src/app/shared/models/capability.ts